import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgClipboardCheckmarkIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M48.813 10.156h-6.876V6.72A1.72 1.72 0 0 0 40.22 5H23.03a1.72 1.72 0 0 0-1.718 1.719v3.437h-6.875A3.44 3.44 0 0 0 11 13.594v42.969A3.44 3.44 0 0 0 14.438 60h34.375a3.44 3.44 0 0 0 3.437-3.437v-42.97a3.44 3.44 0 0 0-3.437-3.437M24.75 8.437H38.5v6.876H24.75zm24.063 48.126H14.438v-42.97h6.874v3.438a1.72 1.72 0 0 0 1.72 1.719h17.187a1.72 1.72 0 0 0 1.718-1.719v-3.437h6.876z" />
      <path d="M31.466 41.543h-2.91l-5.4-6.942L20 37.054l5.4 6.942a3.97 3.97 0 0 0 3.156 1.547h2.91a4.01 4.01 0 0 0 3.4-1.891l8.414-13.543L39.88 28z" />
    </g>
  </svg>
)
export default SvgClipboardCheckmarkIcon
